const shopifyConsentTrackingApiLoadedHandler = (error) => {
  if (error) {
    console.log('Error loading Shopify consent tracking API', error);
  } else {
    console.log('Shopify consent tracking API loaded');
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        sale_of_data: false,
      },
      () => console.log('Shopify tracking consent set')
    );
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    shopifyConsentTrackingApiLoadedHandler
  );
});
